<script setup lang="ts">
import EdroneAlert from "edrone-components/EdroneAlert.vue";

interface LiveEventTask {
  reward: number;
}

interface Options {
  options: {
    liveEventTask: LiveEventTask;
    newLimit: number;
  };
}

defineProps<Options>();
</script>

<template>
  <div class="tw:flex tw:flex-col tw:gap-5 tw:items-center tw:w-full">
    <div
      class="tw:flex tw:justify-center tw:items-center tw:w-16 tw:h-16 tw:rounded-sm tw:bg-green-000 tw:border tw:border-green-100"
    >
      <font-awesome-icon icon="fa-light fa-check-circle" class="tw:text-green-500 tw:size-8" />
    </div>
    <p class="tw:heading-2 tw:text-black">{{ trans._liveEvents.taskCompleted.title }}</p>
    <div class="tw:flex tw:flex-col tw:gap-2 tw:w-full">
      <EdroneAlert note type="tip" :show-icon="false">
        <template #custom-content>
          <div class="tw:flex tw:flex-col tw:gap-2 tw:items-center tw:w-full">
            <p class="tw:body-2 tw:text-default-700 tw:text-center">{{ trans._liveEvents.taskCompleted.yourReward }}</p>
            <p class="tw:heading-2 tw:text-black">
              {{ trans._liveEvents.taskCompleted.reward.replace("{reward}", options.liveEventTask.reward.toString()) }}
            </p>
          </div>
        </template>
      </EdroneAlert>
      <div class="tw:flex tw:gap-1 tw:items-center tw:justify-center">
        <font-awesome-icon icon="fa-light fa-info-circle" class="tw:text-black tw:size-3" />
        <p class="tw:caption">
          {{ trans._liveEvents.taskCompleted.newLimit.replace("{newLimit}", options.newLimit.toString()) }}
        </p>
      </div>
    </div>
  </div>
</template>
